export enum GenderEnum {
  MALE = "MALE",
  FEMALE = "FEMALE",
  OTHER = "OTHER",
  PREFER_NOT_TO_SAY = "PREFER_NOT_TO_SAY",
}

export const getGenderLabel = (gender: GenderEnum): string => {
  switch (gender) {
    case GenderEnum.MALE:
      return "Hombre";
    case GenderEnum.FEMALE:
      return "Mujer";
    case GenderEnum.OTHER:
      return "Otro";
    case GenderEnum.PREFER_NOT_TO_SAY:
      return "Prefiero no decirlo";
  }
};

export const getGenderOptions = (): { value: GenderEnum; label: string }[] => {
  const keys = Object.keys(GenderEnum).filter(
    (key: string) => typeof GenderEnum[key as keyof typeof GenderEnum] === "string",
  );
  return keys.map((val) => {
    const value = GenderEnum[val as keyof typeof GenderEnum];
    return { label: getGenderLabel(value), value };
  });
};
